module.exports = __webpack_public_path__ + "static/swapnil-fa70640df6dd2e031776098d594a60dc.jpg";